import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import { getConfig } from '../api/config';
import { initiateLogin } from '../auth/oidc';
import { useAuth } from '../auth/useAuth';
import UserMenu from './UserMenu';

export default function NavBar() {
  const { role, email, name, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // The API Reference lives at "/" and at /apis/... deep links.
  const onApiDocs = location.pathname.startsWith('/apis');
  // Errors is its own section, not a part of any API's reference: the pages are
  // permanent, unversioned, and reached from `type` URIs in live responses.
  const onErrors = location.pathname.startsWith('/errors');
  const isAuthenticated = role !== 'public';
  const canAccessAdmin = role === 'admin' || role === 'developer';

  const handleLogin = async () => {
    await initiateLogin(await getConfig());
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="nav">
      <div className="nav-brand">
        <span className="nav-logo">⬡</span>
        <span className="nav-title">Skymap Docs</span>
      </div>
      <div className="nav-links">
        <NavLink
          className={({ isActive }) => (isActive || onApiDocs ? 'active' : '')}
          end={true}
          to="/"
        >
          API Reference
        </NavLink>
        <NavLink className={onErrors ? 'active' : ''} to="/errors">
          Errors
        </NavLink>
        {canAccessAdmin && (
          <NavLink className={({ isActive }) => (isActive ? 'active' : '')} to="/admin">
            Admin
          </NavLink>
        )}
        {!isAuthenticated && (
          <NavLink className={({ isActive }) => (isActive ? 'active' : '')} to="/subscribe">
            Subscribe
          </NavLink>
        )}
      </div>
      <div className="nav-auth">
        {isAuthenticated ? (
          <UserMenu label={name ?? email ?? 'Account'} onSignOut={handleLogout} />
        ) : (
          <button className="nav-login" onClick={() => void handleLogin()}>
            Sign in
          </button>
        )}
      </div>
    </nav>
  );
}
